import React from 'react'
import { AddCar } from '../conponents'


export const AddCarPage = () => <AddCar/>